import Collection from '../collection';
import Schedule from '../model/schedule';





export default Collection.extend( {
	endpoint: 'timetables/list?apiVersion=2.0',
    responseAt: 'items',
    countAt: 'total',
    model: Schedule,
} );


// WEBPACK FOOTER //
// ./src/js/collection/schedules.js